export const DEFAULT_LEFT_MATERIAL_ID = "XAUUSD";
export const DEFAULT_RIGHT_MATERIAL_ID = "EURUSD";
export const TRADING_FEED_POLL_MS = 6_000;
export const ALERT_AUTO_DISMISS_MS = 30_000;
export const ALERT_HIGHLIGHT_MS = 1_500;
export const ALERT_MUTE_MS = 5 * 60_000;
export const REFRESH_COOLDOWN_MS = 90_000;
export const DEFAULT_HISTORY_LIMIT = 10;
export const DEFAULT_CLUSTER_LIMIT = 200;

export const STORAGE_KEYS = {
  leftMaterialId: "tradingview.left_material_id",
  rightMaterialId: "tradingview.right_material_id",
  splitRatio: "tradingview.split_ratio",
  soundEnabled: "tradingview.sound_enabled",
  severityThresholds: "tradingview.severity_thresholds",
  mutedUntilTs: "tradingview.muted_until_ts",
} as const;
